import React, { useEffect, useState, useRef } from "react";
import { useDisclosure } from "@mantine/hooks";
import { Image } from "@mantine/core";
import { Issue, Publication } from "@/api/types";
import DetailsModal from "../DetailsModal/DetailsModal";
import { ReactComponent as Shelf } from "@/assets/shelf.svg";
import "./GridView.css";

interface GridViewProps {
  type: "issue" | "publication";
  items: Issue[] | Publication[];
  myItems: Issue[] | Publication[];
  openFlipbook: (pdf: string) => void;
}

const GridView: React.FC<GridViewProps> = ({
  type,
  openFlipbook,
  items,
  myItems,
}) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [activeItem, setActiveItem] = useState<Issue | Publication>();
  const [containerWidth, setContainerWidth] = useState<number>(
    window.innerWidth
  );
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.getBoundingClientRect().width);
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const isMobile = window.innerWidth <= 665;
  const itemWidth = isMobile ? 96 : 154;
  const gap = isMobile ? 8 : 16;
  const padding = isMobile ? 52 : 200;
  const usableWidth = containerWidth - padding;
  const itemsPerRow = Math.max(
    1,
    Math.floor((usableWidth + gap) / (itemWidth + gap))
  );

  const itemRows = [];
  for (let i = 0; i < items.length; i += itemsPerRow) {
    itemRows.push(items.slice(i, i + itemsPerRow));
  }

  const openItemModale = (item: Issue | Publication) => {
    setActiveItem(item);
    open();
  };

  return (
    <div className="grid-view" ref={containerRef}>
      {itemRows.map((row, index) => (
        <div key={index} className="w-full">
          <div className="shelf-row">
            {row.map((item) => (
              <Image
                key={item.id}
                src={item.cover.url}
                className="grid-image"
                onClick={() => openItemModale(item)}
              />
            ))}
          </div>
          <Shelf className="shelf-svg" />
        </div>
      ))}
      {activeItem && (
        <DetailsModal
          opened={opened}
          onClose={close}
          openFlipbook={openFlipbook}
          type={type}
          item={activeItem}
          myItems={myItems}
        />
      )}
    </div>
  );
};

export default GridView;
